import Axios from 'api/client';
import { AxiosResponse } from 'axios';
import { APIKey } from 'types/domain';
import { PaginatedData } from 'types/pagination';

interface CreateAPIKeyRequest {
    name?: string;
}
interface CreateAPIKeyResponse {
    apiKey: APIKey;
    plainTextApiKey: string;
}

const createAPIKey = (accountId: number, data?: CreateAPIKeyRequest) =>
    Axios.post<CreateAPIKeyRequest, AxiosResponse<CreateAPIKeyResponse>>(
        `/accounts/${accountId}/keys`,
        data,
    ).then(response => response.data);

const getAPIKeys = (accountId: number, params: { page?: number; limit?: number }) =>
    Axios.get<PaginatedData<APIKey>>(`/accounts/${accountId}/keys`, { params }).then(
        response => response.data,
    );

const updateAPIKey = (accountId: number, apiKeyId: number, data: { name?: string }) =>
    Axios.patch(`/accounts/${accountId}/keys/${apiKeyId}`, data).then(response => response.data);

const deleteAPIKey = (accountId: number, apiKeyId: number) =>
    Axios.delete(`/accounts/${accountId}/keys/${apiKeyId}`).then(response => response.data);

export { createAPIKey, getAPIKeys, updateAPIKey, deleteAPIKey };
